import { atom } from "recoil";

// (checkup_operation)確定申込情報
export const examOrderState = atom({
  key: "examOrderState",
  default: {
    id: null,
    status: '',
    examdt: '',
    examdtdate: null,
    examdtime: '',
    examclinic_id: '',
    examclinic: null,
    examnote: null,
  },
});